import { render, staticRenderFns } from "./chart.vue?vue&type=template&id=bb508942&scoped=true"
import script from "./chart.vue?vue&type=script&setup=true&lang=js"
export * from "./chart.vue?vue&type=script&setup=true&lang=js"
import style0 from "./chart.vue?vue&type=style&index=0&id=bb508942&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb508942",
  null
  
)

export default component.exports